import React, { useState } from 'react';
import { connect } from 'react-redux';
import { Button, Col, Row } from 'reactstrap';
import DatePicker from 'react-datepicker';
import { CSVLink } from 'react-csv';
import { getFirstDay, dateStrToYmd } from '@/shared/helpers';
import ExportButton from '@/shared/components/ExportButton';

const defaultFrom = getFirstDay();
const defaultTo = new Date();

const CoCardReportFilter = ({
  filter,
  setFilter,
  setUseFilter,
  download,
  exportData,
  exportLink,
  exportHeaders,
  isExporting,
  reportName,
}) => {
  const [from, setFrom] = useState(defaultFrom);
  const [to, setTo] = useState(defaultTo);

  const onClickFilter = (reset = false) => {
    const newFrom = dateStrToYmd(reset ? defaultFrom : from);
    const newTo = dateStrToYmd(reset ? defaultTo : to);

    if (!reset && newFrom === filter.from && newTo === filter.to) {
      alert('No change in filters');
      setUseFilter(false);
      return;
    }

    setFilter({ ...filter, from: newFrom, to: newTo });
    setUseFilter(true);

    if (reset) {
      setFrom(defaultFrom);
      setTo(defaultTo);
    }
  };

  return (
    <Row className="table-filter-form form">
      <Col md={8} lg={8} sm={8} className="table-filter-form-fields">
        <div className="table-filter-form-col table-filter-form-col2 float-filter">
          <div className="form__form-group">
            <span className="form__form-group-label">From</span>
            <div className="form__form-group-field">
              <div className="form__form-group-row">
                <DatePicker dateFormat="MM/dd/yyyy" selected={from} onChange={setFrom} />
              </div>
            </div>
          </div>
        </div>
        <div className="table-filter-form-col table-filter-form-col2 float-filter">
          <div className="form__form-group">
            <span className="form__form-group-label">To</span>
            <div className="form__form-group-field">
              <div className="form__form-group-row">
                <DatePicker dateFormat="MM/dd/yyyy" selected={to} onChange={setTo} />
              </div>
            </div>
          </div>
        </div>
        <div className="clearfix">&nbsp;</div>
      </Col>
      <Col className="align-items-center max-height-32px pl-1">
        <Button onClick={() => onClickFilter()} className="btn btn-sm btn-primary" color="#ffffff">
          Filter
        </Button>
        <Button onClick={() => onClickFilter(true)} className="btn btn-sm btn-primary" color="#ffffff">
          Reset
        </Button>
        <div>
          <ExportButton isExporting={isExporting} onExport={() => download(filter)} />
          <CSVLink
            data={exportData}
            headers={exportHeaders}
            filename={reportName || 'cocard-report.csv'}
            className="hidden"
            ref={exportLink}
            target="_blank"
          />
        </div>
      </Col>
    </Row>
  );
};

const mapStateToProps = (state) => ({ organization: state.organization });
export default connect(mapStateToProps)(CoCardReportFilter);
